import { RealtimePartialStoreState, REALTIME_STATE_KEY } from './realtime.reducer';

export const getLocations = (state: RealtimePartialStoreState) => state[REALTIME_STATE_KEY].locations;

export const getSelectedLocations = (state: RealtimePartialStoreState) => state[REALTIME_STATE_KEY].selectedLocation;

export const getShapes = (state: RealtimePartialStoreState) => state[REALTIME_STATE_KEY].shapes;
